module.exports = __webpack_public_path__ + "img/carousel-2.1ea4efab.png";